import type { RouteObject } from "react-router";
import { ReportHome } from "./ReportHome";
import { InventoryReport } from "./InventoryReport";
import { AdjustmentReport } from "./AdjustmentReport";
import { ReceiptReport } from "./ReceiptReport";
import { ToeReport } from "./ToeReport";
import { EstoreReport } from "./EstoreReport";
import { TollReport } from "./TollReport";
import { dispatchReportRoute } from "./dispatch-report/dispatchReport.routes";
import { Navigate } from "react-router";
import { ORDER_SNAPSHOT_PATH } from "@/features/order/order.paths";

/** The /report subtree: the report home and each report page; /report/snapshot redirects to the order snapshots. */
export const reportRoute: RouteObject = {
  path: "report",
  children: [
    { index: true, element: <ReportHome /> },
    { path: "inventory-report", element: <InventoryReport /> },
    { path: "adjustment-report", element: <AdjustmentReport /> },
    { path: "receipt-report", element: <ReceiptReport /> },
    { path: "toe-report", element: <ToeReport /> },
    { path: "estore-report", element: <EstoreReport /> },
    { path: "toll-report", element: <TollReport /> },
    dispatchReportRoute,
    { path: "snapshot", element: <Navigate replace to={ORDER_SNAPSHOT_PATH} /> },
  ],
};
